import { graphql } from "react-relay";

export const deleteSession = graphql`
  mutation DeleteSession_DeleteSessionMutation {
    deleteSession {
      session {
        loggedOut
      }
      errors {
        message
      }
    }
  }
`;
